import * as React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { I18nextProvider } from 'react-i18next';
import { Store } from 'redux';
import { History } from 'history';
import { i18n as I18n } from 'i18next';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { Keycloak } from '@unitedtraders/keycloak';

interface Props {
  children: React.ReactElement<any>;
  store: Store;
  keycloak: Keycloak;
  history: History;
  i18n: I18n;
  apolloClient: ApolloClient<any>;
}

export const KeycloakContext = React.createContext<Keycloak | null>(null);

const App: React.FC<Props> = ({ children, store, history, apolloClient, i18n, keycloak }) => (
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <KeycloakContext.Provider value={keycloak}>
        <I18nextProvider i18n={i18n}>
          <ConnectedRouter history={history}>{children}</ConnectedRouter>
        </I18nextProvider>
      </KeycloakContext.Provider>
    </Provider>
  </ApolloProvider>
);

export default App;
